module.exports = __webpack_public_path__ + "static/media/Landing Page Banner_Desktop 1x.7bda6a08.webp";